import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './MobileNav.css';

const MobileNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAdmin, isManager } = useAuth();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="mobile-nav no-print">
      <button
        className={`nav-btn ${isActive('/') ? 'active' : ''}`}
        onClick={() => navigate('/')}
        aria-label="Dashboard"
      >
        <span className="nav-icon">📊</span>
        <span className="nav-label">Home</span>
      </button>
      <button
        className={`nav-btn ${isActive('/jobs') ? 'active' : ''}`}
        onClick={() => navigate('/jobs')}
        aria-label="Jobs"
      >
        <span className="nav-icon">🔧</span>
        <span className="nav-label">Jobs</span>
      </button>
      <button
        className={`nav-btn ${isActive('/schedule') ? 'active' : ''}`}
        onClick={() => navigate('/schedule')}
        aria-label="Schedule"
      >
        <span className="nav-icon">📅</span>
        <span className="nav-label">Schedule</span>
      </button>
      <button
        className={`nav-btn ${isActive('/timesheets') ? 'active' : ''}`}
        onClick={() => navigate('/timesheets')}
        aria-label="Timesheets"
      >
        <span className="nav-icon">⏱️</span>
        <span className="nav-label">Time</span>
      </button>
      <button
        className={`nav-btn ${isActive('/profile') ? 'active' : ''}`}
        onClick={() => navigate('/profile')}
        aria-label="Profile"
      >
        <span className="nav-icon">👤</span>
        <span className="nav-label">Profile</span>
      </button>
      {isAdmin && (
        <button
          className={`nav-btn ${isActive('/admin') ? 'active' : ''}`}
          onClick={() => navigate('/admin')}
          aria-label="Admin"
        >
          <span className="nav-icon">⚙️</span>
          <span className="nav-label">Admin</span>
        </button>
      )}
      {isManager && (
        <button
          className={`nav-btn ${isActive('/admin') ? 'active' : ''}`}
          onClick={() => navigate('/admin')}
          aria-label="Manager"
        >
          <span className="nav-icon">⚙️</span>
          <span className="nav-label">Manager</span>
        </button>
      )}
    </nav>
  );
};

export default MobileNav;
